import {Component, cloneElement} from 'react';
import PropTypes from 'prop-types';

// based off of http://stackoverflow.com/questions/667555/detecting-idle-time-in-javascript-elegantly
class WhenIdle extends Component {
    static propTypes = {
        timeLength: PropTypes.number
    };

    static defaultProps = {
        timeLength: 3000
    };

    constructor(props) {
        super(props);
        this.state = {
            idle: false
        };
        this.away = this.away.bind(this);
        this.present = this.present.bind(this);
    }

    away() {
        this.setState({idle: true});
    }

    present() {
        this.setState({idle: false});
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.away, this.props.timeLength);
    }

    componentDidMount() {
        document.addEventListener('keypress', this.present, false);
        document.addEventListener('mousemove', this.present, false);
        document.addEventListener('mousedown', this.present, false);
        document.addEventListener('touchstart', this.present, false);
        document.addEventListener('click', this.present, false);
        document.addEventListener('scroll', this.present, false);
        this.present();
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
        document.removeEventListener('keypress', this.present, false);
        document.removeEventListener('mousemove', this.present, false);
        document.removeEventListener('mousedown', this.present, false);
        document.removeEventListener('touchstart', this.present, false);
        document.removeEventListener('click', this.present, false);
        document.removeEventListener('scroll', this.present, false);
    }

    render() {
        const {idle} = this.state;
        return cloneElement(this.props.children, {
            idle
        });
    }
}

export default WhenIdle;
